export const getSelectSections = (brands, counts) => {
    const data =
        brands
            ?.filter((x) => {
                const id = x?.merkId;
                return counts?.[id] > 0;
            })
            .map((brand) => {
                const id = brand.merkId;
                const count = counts?.[id] || 0;
                const name = brand.naam;
                return {
                    ...brand,
                    id,
                    displayName: name,
                    aantal: count
                };
            }) || [];

    const populairOptions = { label: "Populaire merken" };
    const otherOptions = { label: "Overige merken" };

    populairOptions.options = data.filter((option) => option.populair);
    otherOptions.options = data.filter((option) => !option.populair);

    return [populairOptions, otherOptions];
};
